import { render, staticRenderFns } from "./StatusFlowConfigManagement.vue?vue&type=template&id=006145ba&scoped=true"
import script from "./StatusFlowConfigManagement.vue?vue&type=script&lang=js"
export * from "./StatusFlowConfigManagement.vue?vue&type=script&lang=js"
import style0 from "./StatusFlowConfigManagement.vue?vue&type=style&index=0&id=006145ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006145ba",
  null
  
)

export default component.exports